<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title"><i class="far fa-user-circle"></i>Additional Information Required!</h5>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <p class="label">Please provide invoice notes/description:</p>
          <div class="input-group pdb-20">
            <textarea class="form-control" id="notesInfo" [(ngModel)]="notesInfo" placeholder="add notes here"></textarea>
          </div>
        </div>
      </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-main" (click)="saveNotes(notesInfo)">Continue</button>
</div>
</div>